exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.picto[data-v-65a9dee2] {\n    padding: .5rem .4rem .5rem .6rem;\n}\n.trax-top-left-icon[data-v-65a9dee2] {\n    position: absolute;\n    top: -2px;\n    left: 0px;\n}\n.trax-top-left-icon i[data-v-65a9dee2] {\n    font-size: 12px;\n}\n\n", ""]);

// exports
